import type { ChatAttachment } from './chat-input-attachment.interface'
import { getPlaceholder } from './chat-input-composer.helper'
import type { ChatInputComposerBodyProps } from './chat-input-composer-body.atom'
import type { ChatInputMode } from './chat-input-mode.type'
import type { PromptTemplate } from './prompt-template.interface'
import type { UseChatInputFileReturn } from './use-chat-input-file.hook'
import type { UseChatInputTextareaReturn } from './use-chat-input-textarea.hook'

interface BuildBodyPropsParams {
  value: string
  mode: ChatInputMode
  placeholder?: string
  maxHeight: number
  isDisabled: boolean
  isFileAttachEnabled: boolean
  isLoading: boolean
  isUploading: boolean
  uploadProgress: number
  isNoteMode: boolean
  canSend: boolean
  attachmentList: ChatAttachment[]
  textarea: UseChatInputTextareaReturn
  file: UseChatInputFileReturn
  handleModeChange: (mode: ChatInputMode) => void
  handleSend: () => void
  isStreaming?: boolean
  isStopping?: boolean
  onStop?: () => void
  templateList?: PromptTemplate[]
  handleTemplateSelect?: (templateId: string) => void
  handleCreateTemplate?: () => void
}

/**
 * Builds props object for ChatInputComposerBody component.
 */
export const buildBodyProps = (p: BuildBodyPropsParams): ChatInputComposerBodyProps => ({
  value: p.value,
  mode: p.mode,
  attachmentList: p.attachmentList,
  placeholder: getPlaceholder(p.mode, p.placeholder),
  maxHeight: p.maxHeight,
  isDisabled: p.isDisabled,
  isFileAttachEnabled: p.isFileAttachEnabled,
  isLoading: p.isLoading,
  isUploading: p.isUploading,
  uploadProgress: p.uploadProgress,
  isNoteMode: p.isNoteMode,
  canSend: p.canSend,
  textareaRef: p.textarea.textareaRef,
  fileInputRef: p.file.fileInputRef,
  handleChange: p.textarea.handleChange,
  handleKeyDown: p.textarea.handleKeyDown,
  handlePaste: p.textarea.handlePaste,
  handleFileInputChange: p.file.handleFileInputChange,
  handleRemoveAttachment: p.file.handleRemoveAttachment,
  handleModeChange: p.handleModeChange,
  handleAttachFromComputer: p.file.handleAttachFromComputer,
  handleAttachFromChats: p.file.handleAttachFromChats,
  handleSend: p.handleSend,
  isStreaming: p.isStreaming,
  isStopping: p.isStopping,
  onStop: p.onStop,
  templateList: p.templateList,
  handleTemplateSelect: p.handleTemplateSelect,
  handleCreateTemplate: p.handleCreateTemplate,
})
